import { render, staticRenderFns } from "./ServiceDescriptions.vue?vue&type=template&id=07543200"
import script from "./ServiceDescriptions.vue?vue&type=script&lang=js"
export * from "./ServiceDescriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports